<template>
  <div class="flex flex-col divide-y">
    <PartnersTable :payload="[partner]" :row-style-class="() => ''" />
    <div v-if="partner">
      <PartnerForm
        :partner-id="partnerId"
        :default-value="partner"
        @save="onSaveForm"
      />
    </div>
    <div v-else></div>
  </div>
</template>

<script type="text/javascript">
import PartnerForm from '@/components/Partners/PartnerForm.vue';
import { iwalyNotify } from '@/notify';
import { updateById } from '@/api/partners';
import { mapGetters, mapMutations } from 'vuex';
import PartnersTable from '@/components/Partners/PartnersTable.vue';

export default {
  name: 'PartnersEditPartner',
  components: { PartnersTable, PartnerForm },
  data() {
    return {
      partnerResponse: null,
    };
  },
  computed: {
    ...mapGetters({
      getPartnerById: 'partners/getPartnerById',
    }),
    partnerId() {
      return this.$route.params.id;
    },
    partner() {
      return this.getPartnerById(this.partnerId);
    },
  },
  methods: {
    ...mapMutations({
      mutatePartnerById: 'partners/SET_PARTNER_BY_ID',
    }),
    async onSaveForm(e) {
      try {
        const response = await updateById(this.partnerId, e);
        if (response?.data) {
          this.mutatePartnerById({ id: this.partnerId, payload: response.data });
        }
        iwalyNotify.success({
          text: 'Данные реферрала успешно обновлены',
        });
      } catch (err) {
        iwalyNotify.error({
          text: err,
        });
      }
    },
  },
};
</script>
